(function() {
  // resolve function bef
  angular
    .module('cfn')
    .factory(
      'plantProtectantCoreDataResolver',
      plantProtectantCoreDataResolver
    );

  plantProtectantCoreDataResolver.$inject = ['PlantProtectant'];

  function plantProtectantCoreDataResolver(PlantProtectant) {
    return function() {
      return coreCommonResolveFunction(PlantProtectant, false);
    };
  }
})();
